import { useToggle } from 'ahooks'
import { Avatar, Input, List, Modal, Spin } from 'antd'
import React from 'react'

import { useGetUsersQuery } from '@/generated/graphql'

interface UserSearchProps {
  renderAction: (userId: number) => React.ReactNode
}

const UserSearchComponent: React.FC<UserSearchProps> = ({ renderAction }) => {
  const [search, setSearch] = React.useState('')

  const { data, loading, error } = useGetUsersQuery({
    skip: !search,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    variables: {
      filter: {
        search,
      },
      pagination: {
        first: 10,
      },
    },
  })

  if (error) {
    return null
  }

  if (loading) {
    return <Spin size='large' />
  }

  return (
    <div>
      <Input.Search onSearch={(s) => setSearch(s)} />
      <List
        dataSource={data ? data.users.edges.map(({ node }) => node) : []}
        loading={loading}
        renderItem={(u) => (
          <List.Item actions={[renderAction(u.userId)]}>
            <List.Item.Meta avatar={<Avatar src={u.avatarUrl} />} title={u.name}></List.Item.Meta>
          </List.Item>
        )}
      />
    </div>
  )
}

export const UserSearch: React.FC<UserSearchProps> = (props) => {
  const [visible, { toggle }] = useToggle()
  const child = React.cloneElement(props.children as any, {
    onClick: toggle,
  })
  return (
    <div>
      {child}
      <Modal visible={visible} footer={null} onCancel={() => toggle()}>
        <UserSearchComponent {...props} />
      </Modal>
    </div>
  )
}
